module.exports = __webpack_public_path__ + "img/yilianGl14.6a671f99.png";